import type { RichTextFormatter } from '@manomano-internal/i18n/esm/MessageFormatter';
import { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const {
  manoFulfillmentLabelFree,
  manoFulfillmentLabelFreeExpress
} = translate({
  "manoFulfillmentLabelFree": "Free delivery by Manomano",
  "manoFulfillmentLabelFreeExpress": "Free delivery 48h by ManoMano"
});
export const manoFulfillmentModalContent = translateFormatter<{
  name: string;
  tag: RichTextFormatter;
}>("<tag>Dispatched by {name} for free</tag><tag>Under some conditions</tag>", undefined, undefined, "en");
export const manoFulfillmentModalContentReturn = translateFormatter<{
  name: string;
  tag: RichTextFormatter;
}>("<tag>Dispatched by {name} for free</tag><tag>Under some conditions and for 100 days</tag>", undefined, undefined, "en");
export const manoFulfillmentLabelFreeReturn = translateFormatter<{
  name: string;
}>("Livraison en 48h gratuite et retours gratuits pendant 100 jours par {name}", undefined, undefined, "en");